import { Stack, Title } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import OrderForm from 'components/orders/OrderForm'
import { deliveryCompaniesQuery } from 'hooks/orders'

export const Route = createFileRoute('/_auth/orders/new')({
  component: RouteComponent,
  loader: async ({ context: { queryClient } }) => {
    return await queryClient.ensureQueryData(deliveryCompaniesQuery)
  },
})

function RouteComponent() {
  return (
    <Stack gap="xl">
      <Title order={1}>Nowe zamówienie</Title>
      <OrderForm />
    </Stack>
  )
}
